import React, { useState, useEffect } from 'react';
import { ChevronRight } from 'lucide-react';
import { heroSlides, companyInfo } from '../data/mock';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="hero" style={{ position: 'relative', height: '100vh', minHeight: '600px', overflow: 'hidden' }}>
      {/* Background Slideshow */}
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${slide.image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: currentSlide === index ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
            zIndex: 1
          }}
        >
          {/* Overlay */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.6))',
            zIndex: 2
          }} />
        </div>
      ))}

      {/* Content */}
      <div style={{
        position: 'relative',
        zIndex: 3,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div className="container" style={{ textAlign: 'center', color: '#ffffff' }}>
          <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>
            <h1 
              className="hero-large"
              style={{
                fontSize: 'clamp(28px, 5vw, 48px)',
                lineHeight: '1.2',
                marginBottom: '24px',
                color: '#ffffff',
                fontWeight: '400',
                letterSpacing: '0.5px'
              }}
            >
              {heroSlides[currentSlide].title}
            </h1>
            <p 
              className="body-large"
              style={{
                fontSize: 'clamp(16px, 2.5vw, 20px)',
                lineHeight: '1.6',
                marginBottom: '40px',
                color: '#f6f5e8',
                maxWidth: '700px',
                margin: '0 auto 40px'
              }}
            >
              {heroSlides[currentSlide].subtitle}
            </p>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <a
                href={companyInfo.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                style={{
                  background: '#ffffff',
                  color: '#333333',
                  border: '1px solid #ffffff',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                Konsultasi Sekarang
                <ChevronRight size={16} />
              </a>
              <button
                onClick={() => {
                  const element = document.getElementById('portfolio');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="btn-secondary"
                style={{ color: '#ffffff' }}
              >
                Lihat Portfolio
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div style={{
        position: 'absolute',
        bottom: '40px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 4,
        display: 'flex',
        gap: '12px'
      }}>
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            style={{
              width: currentSlide === index ? '32px' : '12px',
              height: '12px',
              borderRadius: '6px',
              background: currentSlide === index ? '#ffffff' : 'rgba(255,255,255,0.4)',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
